<template>
        <b-nav-item-dropdown class="cx_global_menu_dropdown" :left="!right" :right="right">
          <template slot="button-content">
            <i class="material-icons valign" v-if="icon">{{ icon }}</i>
            <SvgIcon :name="svg" v-if="svg" :width="24" :height="24"/>              
              {{$translate(caption)}}
          </template>          
          <slot></slot>
        </b-nav-item-dropdown>    
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GlobalMenuItem extends Vue {
  @Prop() public to!: string;
  @Prop() public caption!: string;
  @Prop() public selector!: string;
  @Prop({default:null}) public icon?: string;
  @Prop({ default: null }) public svg: string;    
  @Prop({ default: null }) public perm: string;
  @Prop({default:false}) public right:boolean;
  public isActive(path: string) {
    if (path === '/') {
      return this.$route.path === path;
    } else {
      return this.$route.path.startsWith(path);
    }
  }
}
</script>
<style lang="scss">
.cx_global_menu_dropdown {
  i {
    font-size: 28px;
    margin-top: -4px;
    color: white;
    margin-bottom: -5px;
    margin-left: -3px;
    margin-right: -3px;
  }
}

  </style>